import {
  getAppNames,
  registerApplication,
  start,
  unregisterApplication
} from "single-spa";
import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes
} from "single-spa-layout";

import { AuthorizedUser } from "@digital-services/auth";
import { GetAccessTokenFunc } from "@digital-services/shell";

import { CustomPropsModel } from "@/Auth/services/common";

const fotaMifeName = "@emobility/fota";
const commonMifeName = "@emobility/common";

function showExcept(paths: string[]) {
  return (location: Location) =>
    paths.every(path => !location.pathname.startsWith(path));
}

export function createPropsForRoutes(
  getAccessToken: GetAccessTokenFunc,
  user: AuthorizedUser,
  roles: string[]
): CustomPropsModel {
  return {
    user: {
      ...user,
      roles
    },
    getAccessToken
  };
}

export function initSingleSpaApps(
  mainContentEl: HTMLElement,
  propsForRoutes: CustomPropsModel
) {
  const resolvedRoutes = constructRoutes({
    containerEl: mainContentEl,
    routes: [
      {
        type: "route",
        path: "/fota",
        routes: [{ type: "application", name: fotaMifeName }],
        props: propsForRoutes
      },
      {
        type: "route",
        default: true,
        routes: [{ type: "application", name: commonMifeName }],
        props: propsForRoutes
      } // catches all unmatched routes within mife.Shell (not registered not by fotaMifeName nor by commonMifeName)
    ],
    redirects: { "/sign-in": "/" }
  });

  const singeSpaApplications = constructApplications({
    routes: resolvedRoutes,
    loadApp({ name }) {
      return import(
        /* @vite-ignore */
        name
      );
    }
  });

  const layoutEngine = constructLayoutEngine({
    routes: resolvedRoutes,
    applications: singeSpaApplications
  });

  for (const appConfig of singeSpaApplications) {
    if (appConfig.name === commonMifeName) {
      registerApplication(
        appConfig.name,
        appConfig.app,
        showExcept(["/fota"]),
        propsForRoutes
      );
    } else {
      registerApplication(appConfig);
    }
  }

  layoutEngine.activate();

  start();

  return () => {
    const registeredApplications = getAppNames();
    for (const name of registeredApplications) {
      unregisterApplication(name);
    }
    layoutEngine.deactivate();
  };
}
